/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeedPostPillReactionResponse } from '../../models/feed-post-pill-reaction-response';

export interface GetPostPillReactions$Params {
  id: number;
}

export function getPostPillReactions(http: HttpClient, rootUrl: string, params: GetPostPillReactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeedPostPillReactionResponse>>> {
  const rb = new RequestBuilder(rootUrl, getPostPillReactions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeedPostPillReactionResponse>>;
    })
  );
}

getPostPillReactions.PATH = '/api/post-pill/{id}/reactions';
